import LandingPage from "./landingPage"

export default LandingPage
